// extracted by mini-css-extract-plugin
export var contrastLow = "_2z-1";
export var externalLink = "_2z-2";
export var externalLinkIcon = "_2z-3";
export var link = "_2z-0";
export var linkLabel = "_2z-4";